import React from 'react';
import classNames from 'classnames';
import uniqueId from 'uniqid';

import Modal from '../Modal';
import RenderStaticHTML from '../RenderStaticHTML';

const ns = `shop-pay-modal`;

const ShopPayModal = ({
	setShopPayModalOpen,
	shopPayModalOpen,
	content,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<Modal
			modifier={rootClassnames}
			onRequestClose={() => { setShopPayModalOpen(false); }}
			isOpen={shopPayModalOpen}
		>
			<div className={`${ ns }`}>
				<div className={`${ ns }__container`}>
					{content?.title && (
						<h3>{content.title}</h3>
					)}
					{content?.description && (
						<p>{content.description}</p>
					)}
					{content?.list?.length > 0 && (
						<div className={`${ ns }__list`}>
							{content.list.map(bullet => {
								return (
									<div className={`${ ns }__bullet`} key={uniqueId('nn')}>
										<RenderStaticHTML renderDiv={false} html={bullet.icon} />
										<p>{bullet?.label}</p>
									</div>
								);
							})}
						</div>
					)}
					{content?.footnote && (
						<p className={`${ ns }__footnote`}>{content.footnote}</p>
					)}
					{content?.footer && (
						<div className={`${ ns }__footer`}>
							<RenderStaticHTML html={content.footer} />
						</div>
					)}
				</div>
			</div>
		</Modal>
	);
};

export default ShopPayModal;
